import styled, { css } from "styled-components";
import { theme } from "../../../../../../../common-deprecated/styles/v2/toyota/theme/toyotaTheme";
import { getBreakpoint } from "../../../../../../../common-deprecated/themes/common";

export const DropDown = styled.div`
    padding: ${theme.space[3]}px 0 0;
`;

export const DropDownTitle = styled.span.attrs(() => ({
    className: "sub-epsilon-text",
}))`
    display: flex;
    gap: ${theme.space[1]}px;
    margin-bottom: 0 !important; /* Override foundation style */
    font-size: 1.6rem;

    @media ${getBreakpoint("up", "lg")} {
        font-size: 2rem;
    }
`;

export const Wrapper = styled.div<{ isOpen?: boolean }>`
    padding: 32px 0 ${theme.space[3]}px;
    border-bottom: 1px solid ${({ isOpen }) => (isOpen ? "transparent" : theme.colors.grey2)};

    ${({ isOpen }) =>
        isOpen &&
        css`
            padding-bottom: 0;
            ${DropDown} {
                margin-bottom: ${theme.space[1]}px;
            }
        `};
`;

export const DropDownAction = styled.button`
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: 0;
    cursor: pointer;
`;
